// Průměrný součinitel prostupu tepla budovy
export const TextsStepAvgHeatTransferOfBuildingPENB: Array<string> = [
    `<strong>Průměrný součinitel prostupu tepla budovy</strong> je první řádek v sekci 
    Ukazatele energetické náročnosti na přední straně průkazu.`,
    `Hodnota by měla být větší než nula a menší než 0,30 W/m<sup>2</sup>K.`
]

// Celková plocha hodnocené obálky budovy
export const TextsStepTotalAreaOfEvaluatedBuildingCoverPENB: Array<string> = [
    `<strong>Celkovou plochu obálky budovy</strong> naleznete v sekci 
    Geometrické charakteristiky na zadní straně průkazu.`,
    `Hodnota by měla být několik set m<sup>2</sup> u větších budov i několik tisíc m<sup>2</sup>.`
]

// Ztráty energie
export const TextsStepEnergyLossPENB: Array<string> = [
    `<strong>Ztráty energie</strong> naleznete v sekci 
    Bilance tepelných toků na zadní straně průkazu.`,
    `Zadejte prosím hodnoty pro Větrání, Netěsnosti obálky - infiltrace a Celkem.`
]

// Měrná ztráta prostupem tepla
export const TextsStepMeasuredHeatLossPENB: Array<string> = [
    `<strong>Měrnou ztrátu prostupem tepla</strong> naleznete v sekci A) Stavební prvky v posledním sloupci tabulky a.1 požadavky na součinitel prostupu tepla W/K.`,
    `Zadejte celkovou hodnotu v W/K.`
]

// Měrná ztráta prostupem tepla TC
export const TextsStepMeasuredHeatLossPENBtc: Array<string> = [
    `<strong>Měrnou ztrátu prostupem tepla</strong>  naleznete v posledním sloupci tabulky a.1 požadavky na součinitel prostupu tepla v sekci A) Stavební prvky a konstrukce.`,
    `Zadejte celkovou hodnotu v W/K.`
]

// Objem budovy V
export const TextsStepBuildingVolumeVPENB: Array<string> = [
    `<strong>Objem budovy V</strong> naleznete na prvním řádku v sekci 
    Geometrické charakteristiky budovy.`,
    `Hodnota by měla být několik set m<sup>3</sup> u větších budov i několik tisíc m<sup>3</sup>`
]

// Objem budovy V - tc
export const TextsStepBuildingVolumeVPENBtc: Array<string> = [
    `<strong>Objem budovy V</strong> naleznete na prvním řádku v sekci 
    Geometrické charakteristiky budovy na zadní straně průkazu.`,
    `Hodnota by měla být několik set m<sup>3</sup> u větších budov i několik tisíc m<sup>3</sup>`
]